export default __webpack_public_path__ + "static/media/symmetra-shield.0492ae75.mp3";